export type BadgeType =
  | 'IN_SCOPE'
  | 'OUT_OF_SCOPE'
  | 'NEW'
  | 'REPLACE'
  | 'RETAIN'
  | 'NOT_RELEVANT'
  | 'NO_SYSTEM'
  | 'NON_HR_TOOL';

export const BADGE_CONFIG: Record<BadgeType, {letter: string; class: string; textClass: string}> = {
  // Status in Project Types
  IN_SCOPE: {letter: 'S', class: 'bg-red-600', textClass: 'text-white'},
  OUT_OF_SCOPE: {letter: 'O', class: 'bg-gray-500', textClass: 'text-white'},

  // Transformation Types
  NEW: {letter: 'N', class: 'bg-blue-600', textClass: 'text-white'},
  REPLACE: {letter: 'R', class: 'bg-green-600', textClass: 'text-white'},
  RETAIN: {letter: 'K', class: 'bg-orange-700', textClass: 'text-white'},
  NOT_RELEVANT: {letter: 'A', class: 'bg-amber-500', textClass: 'text-white'},
  NO_SYSTEM: {letter: 'I', class: 'bg-cyan-500', textClass: 'text-white'},

  // Tool Types
  NON_HR_TOOL: {letter: 'X', class: 'bg-teal-600', textClass: 'text-white'},
};
